import { SkeletonProductSection } from '../../components/skeletons/SkeletonSection';
import { ProductSection } from './ProductSection';
import { useFormattedClubeRoutes } from './home.store';

export const ClubeSection = () => {
  const { items, product, isLoading } = useFormattedClubeRoutes();

  if (isLoading) {
    return <SkeletonProductSection />;
  }

  return (
    <ProductSection color={product.color} product={product} items={items} />
  );
};
